"use strict";

define('controller/submission/detail',['require','exports','module','../base','underscore','model/document','model/study','model/sort','model/checklist','model/document.permission','model/document.letter','model/document.decision','model/attachment','model/meeting','model/task','model/workflow.routing','model/role','model/person','collection/common.rule.collection','collection/assignments','libs/route.helper','adapter/param','../../view/submission/submission.detail','langs'],function (require, exports, module) {
  var RegionController = require('../base'),
    _ = require('underscore'),
    Document = require('model/document'),
    Study = require('model/study'),
    Sort = require('model/sort'),
    ChecklistModel = require('model/checklist'),
    DocumentPermission = require('model/document.permission'),
    DocumentLetterModel = require('model/document.letter'),
    DocumentDecisionModel = require('model/document.decision'),
    AttachmentModel = require('model/attachment'),
    MeetingModel = require('model/meeting'),
    TaskModel = require('model/task'),
    WorkflowRoutingModel = require('model/workflow.routing'),
    RoleModel = require('model/role'),
    PersonModel = require('model/person'),
    CommonRuleCollection = require('collection/common.rule.collection'),
    Assignments = require('collection/assignments'),
    RouteHelper = require('libs/route.helper'),
    ParamAdapter = require('adapter/param'),
    SubmissionDetailView = require('../../view/submission/submission.detail'),
    langs = require('langs');
  var SubmissionDetailController = RegionController.extend({
    header: langs.phrase('App.Title'),
    onStart: function onStart() {
      var app = this.app;
      var region = this.region,
        state = this.state,
        documentId = parseInt(state.get('documentId')),
        studyId = parseInt(state.get('studyId')),
        study = new Study({
          id: studyId
        }),
        submission = new Document({
          id: documentId
        }),
        studyService = app.service('study'),
        studyAssignments = new Assignments().params({
          entityType: 'study',
          entityId: studyId
        }),
        assignments = new Assignments().params({
          entityType: 'document',
          entityId: documentId
        }),
        permissions = DocumentPermission.allByDocumentId(documentId),
        commonRuleOptions = new CommonRuleCollection(),
        letters = DocumentLetterModel.allByDocumentId(documentId),
        submissionAttachments = AttachmentModel.createCollection(AttachmentModel.SUBMISSION_ATTACHMENT_URL).params({
          documentId: submission.id
        }),
        tasks = TaskModel.allBySubmissionId(documentId),
        tasksHistory = TaskModel.allHistoryByDocumentId(documentId),
        approvals = WorkflowRoutingModel.allApprovals(documentId),
        checklists = ChecklistModel.allOpen(documentId),
        hChecklists = ChecklistModel.allHistorical(documentId),
        meetings = MeetingModel.collectionByDocumentId(documentId),
        openDecisions = new Backbone.Collection([], {
          model: DocumentDecisionModel
        }),
        decisions = DocumentDecisionModel.allByDocumentId(documentId).addAdapter({
          filter: function filter(data) {
            openDecisions.reset(_.filter(data || [], function (m) {
              return !m.finalizedDate;
            }));
            return _.filter(data || [], function (m) {
              return m.finalizedDate;
            });
          }
        }),
        roles = RoleModel.all(),
        analysts = PersonModel.allByRoleId().addAdapter(new ParamAdapter(Sort.createWithSort('person.lastName')));
      var uploadHandler = AttachmentModel.buildUploadHandler(app, AttachmentModel.SUBMISSION_ATTACHMENT_URL, {
        documentId: submission.id
      }, submissionAttachments.fetch.bind(submissionAttachments));
      var stampApplicationHandler = function stampApplicationHandler() {
        var idsOfAttachmentsToStamp = _.reduce(submissionAttachments.models, function (ids, attachment) {
          if (attachment.get('stampPending')) {
            ids.push(attachment.id);
          }
          return ids;
        }, []);
        AttachmentModel.applyStamps(decisions, idsOfAttachmentsToStamp, submissionAttachments);
      };
      var submissionDetailView = new SubmissionDetailView({
        app: app,
        state: state,
        overlay: app.overlay,
        className: 'full size',
        model: submission,
        study: study,
        assignments: assignments,
        studyAssignments: studyAssignments,
        attachments: submissionAttachments,
        permissions: permissions,
        commonRuleOptions: commonRuleOptions,
        approvals: approvals,
        decisions: decisions,
        openDecisions: openDecisions,
        meetings: meetings,
        letters: letters,
        tasks: tasks,
        tasksHistory: tasksHistory,
        checklists: checklists,
        historicalChecklists: hChecklists,
        analysts: analysts,
        allowApplyStamps: this.userHasPermission('IRB_MODIFY_ATTACHMENT_STAMPS'),
        canUpload: this.userHasPermission('IRB_MODIFY_ATTACHMENT_STAMPS'),
        canStamp: this.userHasPermission('IRB_MODIFY_ATTACHMENT_STAMPS'),
        canModifyStudy: this.userHasPermission('MODIFY_STUDY'),
        uploadHandler: uploadHandler,
        stampApplicationHandler: stampApplicationHandler,
        useSubmissionDetailsHeader: true,
        submissionDetailsHeaderText: langs.phrase('Submissions.Details.Title')
      });
      letters.comparator = function (a, b) {
        return b.get('dateSent') > a.get('dateSent');
      };
      decisions.comparator = function (a, b) {
        return b.get('finalizedDate') > a.get('finalizedDate');
      };
      submissionDetailView.$el.css({
        padding: '2em'
      });
      submissionDetailView.breadcrumb.collection = new Backbone.Collection([{
        text: 'Studies',
        link: RouteHelper.resolve('study:list')
      }, {
        text: 'Study Details',
        link: RouteHelper.createLink('study:detail', study, {
          studyId: 'id'
        })
      }, {
        text: langs.phrase('Submissions.Details.Title')
      }]);
      function fetchAllProperties() {
        return submission.fetch().promise().tap(function () {
          return Promise.join(assignments.fetch(), studyAssignments.fetch(), permissions.fetch(), commonRuleOptions.fetch(), letters.fetch(), decisions.fetch(), approvals.fetch(), tasks.fetch(), tasksHistory.fetch(), checklists.fetch(), hChecklists.fetch(), meetings.fetch(), submissionAttachments.fetch());
        }).tap(function () {
          submission.trigger('allFetched');
        });
      }
      var pageModels = [study, roles, analysts, submission, assignments, studyAssignments, permissions, commonRuleOptions, letters, decisions, approvals, tasks, tasksHistory, checklists, hChecklists, meetings];
      state.once('page:loaded', function () {
        region.show(submissionDetailView);
      }).once('page:error', function () {
        studyService.navigateToStudy(study);
      });
      state.addPageDependencies(pageModels);
      study.fetch().promise().tap(function () {
        return roles.fetch();
      }).tap(function () {
        var role = roles.findWhere({
          name: 'ROLE_IRB_ANALYST'
        });
        analysts.params({
          roleId: role.get('id')
        });
        return analysts.fetch();
      }).tap(function () {
        return fetchAllProperties();
      });
      submission.on('updateAll', function () {
        fetchAllProperties()["finally"](submissionDetailView.showDimmer());
      });
      submission.on('destroy', function () {
        _.defer(function () {
          var link = RouteHelper.createLink('study:detail', study, {
            studyId: 'id'
          });
          app.navigate(link, {
            trigger: true
          });
        });
      });
      submissionDetailView.listenTo(study, 'sync', function () {
        var studyListModel = submissionDetailView.breadcrumb.collection.at(0),
          isArchived = !!study.get('finalizedDate');
        studyListModel.set({
          link: RouteHelper.resolve('study:list', {
            type: isArchived ? 'archive' : 'active'
          })
        });
      });
      submissionDetailView.attachmentsTabView.setupPaginate().setupPageSizes().setupTableSort().setupLoading().setupSearch('').spfHelper.setupAutoFetch().setSortField('createDate').setSortDirection('ascending').setPaginateSize(10);
    }
  });
  module.exports = SubmissionDetailController;
});

